import { z } from 'zod'

const LocationQtySchema = z.object({
  location: z.string(),
  qty: z.number(),
})

const ItemLotSchema = z.object({
  itemId: z.number(),
  lotNo: z.string(),
  lotDate: z.string(),
  mold: z.string(),
  isClaimItem: z.boolean(),
  partyId: z.number().nullable(),
  unit: z.string(),
})

const ItemSchema = z.object({
  id: z.number(),
  seq: z.number(),
  qty: z.number(),
  refNo: z.string().nullable(),
  refId: z.number().nullable(),
  refItemId: z.number().nullable(),
  item: ItemLotSchema,
  fromLocations: z.array(LocationQtySchema),
  toLocations: z.array(LocationQtySchema),
})

export const Inv1140GetResultSchema = z.object({
  id: z.number(),
  number: z.string(),
  date: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string().nullable(),
  refDate: z.string().nullable(),
  remark: z.string().nullable(),
  fromStatus: z.number(),
  toStatus: z.number(),
  items: z.array(ItemSchema),
  status: z.number(),
})

export type Inv1140GetResultModel = z.input<typeof Inv1140GetResultSchema>
